import { render, staticRenderFns } from "./AdminAffiliatesElement.vue?vue&type=template&id=0a6fe008&scoped=true"
import script from "./AdminAffiliatesElement.vue?vue&type=script&lang=js"
export * from "./AdminAffiliatesElement.vue?vue&type=script&lang=js"
import style0 from "./AdminAffiliatesElement.vue?vue&type=style&index=0&id=0a6fe008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fe008",
  null
  
)

export default component.exports